import { Box, Text } from "@chakra-ui/react";

const NoRequest = () => {
  return (
    <Box mt="16px">
      <Text mb="0px" fontSize="13px" lineHeight="24px">
        The lender has not requested proof of funds yet.
      </Text>
    </Box>
  );
};

export default NoRequest;
